<template>
    <section class="section-positions-hero" :style="{backgroundImage: `url(${bg})`}">
        <div class="container content-wrapper">
            <div class="content" :class="`bg-gradient--${theme}`">
                <h1 class="heading heading--xl text-uppercase" v-html="title" ></h1>
                <slot></slot>
                <!--<p class="paragraph">We’re always on the lookout for talented people to join our team. Whether your expertise is in programming, art, design, animation, testing, publishing, or something else — we all share one common goal: to create rich gaming experiences based on various topics of fascination. </p>-->
                <!--<BasicButton type="black">View Open Positions</BasicButton>-->
            </div>
        </div>
    </section>
</template>

<script>
    import BasicButton from '../BasicButton'

    export default {
        name: 'hero-constructor',
        components: {
            BasicButton
        },
        props: {
            bg: {
                type: String,
                required: true,
            },
            theme: {
                type: String,
                required: true,
                validator(val) {
                    return ['primary', 'green', 'blue'].indexOf(val) >= 0
                }
            },
            title: {
                type: String,
                required: true
            }
        },
    }
</script>

<style scoped lang="scss" type="text/scss">
    @import "../../assets/scss/globals";
    @import "../../assets/scss/mixins";

    .section-positions-hero {
        background: no-repeat center;
        background-size: cover;


    }

    .content-wrapper {
        min-height: 100vh;
        display: flex;
        align-items: center;

        @media (max-width: $mq-xs-max) {
            align-items: flex-end;
            min-height: auto;
        }
    }

    .content {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        font-size: 1rem;
        padding: em(75) em(110) em(71) em(98);
        width: 720px;
        min-height: 620px;
        *:last-child {
            margin-top: auto;
        }

        .heading {
            color: $text-strong;
            line-height: 1.23;
            margin-bottom: 10px;
            min-height: 176px;
        }

        .paragraph {
            font-size: 16px;
            margin-bottom: 30px;
            line-height: 1.75;
        }

        @media (max-width: $mq-lg-max) {
            font-size: 0.65rem;
            width: 600px;
            min-height: 490px;

            .heading {
                font-size: 52px;
                min-height: 126px;
            }

            &__link {
                margin-top: 40px;
                font-size: 15px !important;
            }
        }

        @media (max-width: $mq-md-max) {
            width: 540px;

            .heading {
                min-height: auto;
            }

            .paragraph {
                font-size: 16px;
            }
        }

        @media (max-width: $mq-xs-max) {
            width: 100%;
            max-width: none;
            height: 100%;
            padding: 30px;
            padding-top: 70px;

        }

        @media (max-width: $mq-xs) {
            .heading {
                font-size: 36px;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/common/HerroConstructor.vue